<template>
  <div>
    <page-header :title="$t('scope.text_290')" />
    <page-body>
      <account-manager-list :id="listId" :getParams="getParams" />
    </page-body>
  </div>
</template>

<script>
import AccountManagerList from './components/List'

export default {
  name: 'AccountManagerIndex',
  components: {
    AccountManagerList,
  },
  data () {
    return {
      listId: 'account-manager-list',
      getParams: {
        details: true,
      },
    }
  },
}
</script>
